export const NEW_CREDENTIALS_PATH = "/nadaj-nowy-login";
export const NEW_CREDENTIALS_CONFIRM_PATH = "/potwierdz-nowy-login";
export const LOGIN_PATH = "/";
export const MIGRATION_IN_PROGRESS_PATH = "/trwa-migracja";
export const PASSWORD_RECOVERY_PATH = "/reset-hasla";
